/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-negated-condition */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import { invoicesColumns, showSequenceNumber } from 'utils/constants';
import {
  INVOICES_QUERY,
  INVOICES_QUERY_SUBSCRIPTION,
} from 'utils/CommonGraphQL';
import { cloneDeep, isEmpty } from 'lodash';
import Loader from 'components/common/Loader';

const Pending = () => {
  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'invoiceStatus',
        value: 'INVOICE_UNPAID',
        type: 'STRING',
        op: 'EQ',
      },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
  });

  const { data, loading, error, subscribeToMore } = useQuery(INVOICES_QUERY, {
    variables: { ...filters },
    fetchPolicy: 'network-only',
  });

  const findIndexOfItem = (item) => {
    return invoicesColumns.findIndex((itm) => itm.accessorKey === item);
  };
  invoicesColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);

  useEffect(() => {
    const unsubscribe = subscribeToMore({
      document: INVOICES_QUERY_SUBSCRIPTION,
      variables: { ...filters },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.invoices.invoices.findIndex(
          (val) => val.id === subscriptionData.data.invoices.invoice.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (subscriptionData.data.invoices.action === 'CREATED') {
          const newInvoices = subscriptionData.data.invoices.invoice;
          const updatedInvoices = [newInvoices, ...newData.invoices.invoices];

          const newTotalCount = prev.invoices.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.invoices = {
            ...newData.invoices,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            invoices: updatedInvoices,
          };
        }
        if (subscriptionData.data.invoices.action === 'UPDATED') {
          newData.invoices.invoices[indexFound] =
            subscriptionData.data.invoices.invoice;
        }

        if (subscriptionData.data.invoices.action === 'DELETED') {
          const { id } = subscriptionData.data.invoices.invoice; // ID of the invoice to remove
          const prevInvoices = prev.invoices.invoices;

          const updatedInvoices = prevInvoices.filter((val) => val.id !== id);

          const newTotalCount = prev.invoices.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedInvoicesData = {
            ...newData.invoices,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            invoices: updatedInvoices,
          };
          newData.invoices = updatedInvoicesData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  if (error) return `There is an error on this page : ${error.message} `;
  if (loading) return <Loader />;
  if (!data?.invoices?.invoices) return 'Invoices not available';
  const { totalCount, totalPages } = data.invoices;

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };

  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  return (
    <FSBTable
      data={data?.invoices?.invoices}
      columns={invoicesColumns}
      totalCount={totalCount || 0}
      totalPages={totalPages || 0}
      currentPageNo={filters.pageNo}
      pageSize={filters.pageSize}
      keyField="id"
      showSearch={false}
      showFilters={false}
      showDelete={false}
      showPagination={false}
      remote
      striped={false}
      hover={false}
      bordered={false}
      wrapperClass="table-responsive word-break"
      handlePageChange={handlePageChange}
      onSortChange={onSortChange}
      sorting={sortBy}
      searchPlaceholder="Search Vendors"
    />
  );
};
export default Pending;
